import React from "react";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import SvgIcon from "../parts/SvgIcon";

class LoginProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      avatar: "",
    };
    this.selectFile = this.selectFile.bind(this);
    this.handleAvatarChange = this.handleAvatarChange.bind(this);
  }

  selectFile(e, edit, handler) {
    e.preventDefault();
    e.stopPropagation();
    const avatarInput = document.getElementById("avatar-input");
    if (this.state.avatar === "" || edit) {
      avatarInput.click();
    } else
      this.setState(
        (prevState) => Object.assign({}, prevState, { avatar: "" }),
        () => {
          avatarInput.value = "";
          handler(avatarInput);
        }
      );
  }

  handleAvatarChange(e, handler) {
    e.persist();
    if (typeof e.target.files[0] === "object") {
      this.setState(
        (prevState) =>
          Object.assign({}, prevState, { avatar: e.target.files[0] }),
        () => {
          handler(e);
          const reader = new FileReader();
          const img = document.getElementById("avatar");
          reader.onload = (event) => (img.src = event.target.result);
          reader.readAsDataURL(e.target.files[0]);
        }
      );
    }
  }

  componentDidMount() {
    document.querySelector('input[name="firstName"]').focus();
  }

  render() {
    const { onBack, submitUserName, handleFieldChange, firstName, lastName } =
      this.props;

    return (
      <LoginWrapper
        mainClass="Onboarding athlete"
        left={
          <form method="POST" data-noreset onSubmit={submitUserName}>
            <BackArrowButton onBack={(_) => onBack(0)} />
            <div>
              <h1 className="!mb-28">Create your profile</h1>
            </div>

            <section className="!flex justify-center mb-12">
              <div
                onClick={(e) => this.selectFile(e, true, handleFieldChange)}
                className="avatar-wrapper"
              >
                <div className="upload-icon-wrapper">
                  <div className="upload-icon"></div>
                </div>
                {this.state.avatar !== "" && (
                  <div
                    className="upload-icon-wrapper remove-wrapper"
                    onClick={(e) =>
                      this.selectFile(e, false, handleFieldChange)
                    }
                  >
                    <div className="remove-icon"></div>
                  </div>
                )}
                {this.state.avatar === "" ? (
                  <SvgIcon src="/img/new-icons/vuesax-linear-user.svg" />
                ) : (
                  <img id="avatar" className="avatar" src={""} />
                )}
              </div>

              <input
                id="avatar-input"
                className="hidden"
                type="file"
                name="avatar"
                placeholder="Add profile picture"
                accept="image/*"
                onChange={(e) => this.handleAvatarChange(e, handleFieldChange)}
              />
            </section>

            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              name="firstName"
              placeholder="Enter first name"
              value={firstName}
              required
              onChange={handleFieldChange}
              sz="large"
            />

            <label htmlFor="lastName" className="mt-6">
              Last Name
            </label>
            <input
              type="text"
              name="lastName"
              placeholder="Enter last name"
              value={lastName}
              required
              onChange={handleFieldChange}
              sz="large"
            />

            <button
              data-button-type="primary"
              sz="large"
              onClick={submitUserName}
            >
              Continue
            </button>
          </form>
        }
      />
    );
  }
}

export default LoginProfileView;
